'use client'

import DisplayHome, { SkeletonCard } from '@component/card/builder/displayHome'
import Select from '@component/select'
import { HOUSE_BEDROOMS, HOUSE_BATHROOMS } from '@config'
import useFetch from '@hooks/useFetch'
import { assign, first, map, range } from 'lodash-es'
import { useMemo, useState } from 'react'

export default function DisplayHomeContent({
  suburbs,
  list,
  builder
}) {

  const [suburb, setSuburb] = useState(first(suburbs))
  const [bed, setBed] = useState(first(HOUSE_BEDROOMS))
  const [bath, setBath] = useState(first(HOUSE_BATHROOMS))

  const params = useMemo(() => {
    if (!suburb.value && !bed.value && !bath.value) return

    return assign(
      {
        typeId: 1,
        builderBrandId: builder.brand.id
      },
      suburb.value ? { suburbId: suburb.value } : undefined,
      bed.value ? { bedrooms: bed.value } : undefined,
      bath.value ? { bathrooms: bath.value } : undefined,
    )
  }, [suburb, bed, bath, builder])

  const { data, isLoading } = useFetch(params ? { url: 'display-homes', params } : null)
  const viewData = params ? data : list

  return (
    <div>
      <div className='text-font text-1xl'>Display Homes</div>
      <div className='text-font-secondary2 text-base mt-14'>Contact your nearest home builder franchise for a complete list of showhome locations.</div>
      <div className='mt-20 flex items-center gap-x-20'>
        <Select data={suburbs} value={suburb} onChange={setSuburb}></Select>
        <Select prefix='Bedrooms: ' data={HOUSE_BEDROOMS} value={bed} onChange={setBed}></Select>
        <Select prefix='Bathrooms: ' data={HOUSE_BATHROOMS} value={bath} onChange={setBath}></Select>
      </div>
      <div className='mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-16'>
        {
          isLoading && (
            map(range(0, 4), idx => (
              <SkeletonCard key={idx}></SkeletonCard>
            ))
          )
        }
        {
          !isLoading && map(viewData, item => (
            <DisplayHome key={item.id} data={item} className='flex flex-col' builder={builder}></DisplayHome>
          ))
        }
      </div>
    </div>
  )
}